import { updateCart, removeItemFromCart } from './cart-service.js';

// Cart page quantity → cart.js sync helper
// Listens for rc-quantity-input events within the main cart items surface
// and uses updateCart to push changes to Shopify.
(() => {
  const U = window.umbrellaConfig || {};
  const events = U.events || {};
  const surface = document.querySelector('cart-items');
  if (!surface) return;

  const handleQuantityEvent = (event) => {
    if (!event || !event.detail) return;
    const { id, key, value } = event.detail;
    const targetId = key || id; // prefer cart line key when available
    if (!targetId || typeof value !== 'number') return;
    // If quantity reaches 0, treat this as a remove for cart UX
    if (value <= 0) {
      removeItemFromCart(targetId);
      const line = event.target && event.target.closest('.cart-item-surface');
      if (line && line.parentElement) line.parentElement.removeChild(line);
      return;
    }

    updateCart(targetId, value);
  };

  const incEvt = events.quantityIncrement || 'quantity:increment';
  const changeEvt = events.quantityChange || 'quantity:change';

  // Rely on the unified quantityChange signal, which rc-quantity-input
  // now emits after every successful increment/decrement or direct edit.
  surface.addEventListener(changeEvt, handleQuantityEvent);
})();
